import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdminTokenHttpInterceptor } from './admin-token-http-interceptor';
import { InternalRequestHttpInterceptor } from './internal-request-http-interceptor';
import { GlobalUnauthorizedInterceptor } from './global-unauthorized.interceptor';

export const internalRequestHttpInterceptorProvider = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: InternalRequestHttpInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AdminTokenHttpInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: GlobalUnauthorizedInterceptor,
        multi: true
    }
];
